import { render } from "./ProduitTransportLocationPage.vue?vue&type=template&id=0edc4cbf"
import script from "./ProduitTransportLocationPage.vue?vue&type=script&lang=js"
export * from "./ProduitTransportLocationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__